import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import Sign from '@alltrails/denali/illustrations/Sign';
import styles from './errors.module.scss';

const ErrorContent = (): JSX.Element => (
  <div className={styles.container}>
    <Sign />
    <div className={styles.error}>
      <Typography color="secondary" component="div" variant="heading500">
        <FormattedMessage defaultMessage="500" />
      </Typography>
    </div>
    <div className={styles.header}>
      <Typography component="div" variant="heading600">
        <FormattedMessage defaultMessage="Looks like we went off the trail" />
      </Typography>
    </div>
    <div className={styles.textContainer}>
      <div className={styles.text}>
        <Typography component="div" variant="paragraph300">
          <FormattedMessage defaultMessage="There seems to be a problem with our server. We're working hard to resolve the issue and should be back to normal soon." />
        </Typography>
      </div>
    </div>
    <div className={styles.buttonContainer}>
      <Button
        linkInfo={{ href: '/explore' }}
        text={<FormattedMessage defaultMessage="Find your next trail" />}
        type="button"
        size="md"
        testId="FiveHundred-explore"
        variant="primary"
      />
    </div>
  </div>
);

export default ErrorContent;
